module.exports = __webpack_public_path__ + "static/media/tagalog.83456ab4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/tagalog.svg
// module id = 372
// module chunks = 1